var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-container"},[_c('TopHeader'),_c('div',{staticClass:"layout-body"},[_c('LeftMenuTree'),_c('div',{staticClass:"main-content"},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }